<template>
  <div id="home">
    <el-form :model="InvoicingInfo.orderInfo" label-width="110px" style="background-color: white;">
      <el-form-item :label="$t('INVOICINGINFO.TOTALPRICE')">
        <span>{{ getTotalPrice(InvoicingInfo.orderInfo)}}</span>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.INVOICINGPRICE')">
        <span>{{ getInvoicingPrice(InvoicingInfo.orderInfo)}}</span>
        <span style="margin-left: 20px;color:blue">{{ getInvoicingDetail(InvoicingInfo.orderInfo)}}</span>
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.INVOICINGCOMPANY')" label-width="28.5rem" v-if="InvoicingInfo.invoicingTitle == 1">
      </el-form-item>
      <el-form-item :label="$t('INVOICINGINFO.INVOICINGCOMPANY1')" label-width="35rem" v-if="InvoicingInfo.invoicingTitle == 2">
      </el-form-item>
    </el-form>
    <!-- 发票类型 start -->
    <el-form label-width="110px" class="info_form">
      <el-form-item :label="$t('H5INVOICINGINFO.INVOICINGTYPETITLE')" style="text-align: right;font-weight: bold;">
      </el-form-item>
      <van-form>
        <van-cell :is-link="!InvoicingInfo.showForm" :title="InvoicingInfo.choseInvoicingType == 1 ? this.$t('INVOICINGTYPE.NORMAL') : this.$t('INVOICINGTYPE.APPRECIATE')" :label="invoicingTypeTips" @click="!InvoicingInfo.showForm ? showInvoicingType() : false;"></van-cell>
      </van-form>
    </el-form>
    <!-- 发票类型 end -->
    <!-- 发票信息 start -->
    <el-form label-width="110px" class="info_form">
      <el-form-item :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TITLE')" style="text-align: right;font-weight: bold;">
        <a href="javascript:void(0);" @click="instruction" target="_self" style="margin-right: 2rem;font-weight: normal;">{{ $t('INVOICINGINFO.INVOICINGDETAILINFO.INSTRUCTION') }}</a>
      </el-form-item>
      <van-form>
        <van-radio-group v-model="InvoicingInfo.choseinvoicing.invoiceType" direction="horizontal" @change="changeInvoiceType" :disabled="InvoicingInfo.showForm">
          <van-radio name="2" :disabled = "InvoicingInfo.showInvoiceTypeRadio">{{ $t("INVOICINGHEADERTYPE.PERSONS") }}</van-radio>
          <van-radio name="1" :disabled = "InvoicingInfo.showInvoiceTypeRadio">{{ $t("INVOICINGHEADERTYPE.CORPORATION") }}</van-radio>
          <van-radio name="3" :disabled = "!InvoicingInfo.showInvoiceTypeRadio">{{ $t("INVOICINGHEADERTYPE.NOCORPORATION") }}</van-radio>
        </van-radio-group>
        <van-cell
          :is-link="!InvoicingInfo.showForm"
          :clickable="!InvoicingInfo.showForm"
          :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')"
          :value="invoicingHeader"
          @click="showInvoiceHeader"
          required
        ></van-cell>
        <van-cell :is-link="!InvoicingInfo.showForm" :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')" :value="taxCode" v-if="showTaxRegisterNumber"></van-cell>
      </van-form>
    </el-form>
    <!-- 发票信息 end -->
    <!-- 接收方式 start -->
    <el-form label-width="110px" class="info_form">
      <el-form-item :label="$t('INVOICINGINFO.CONTACTSINFO.CONTACTSMSG')" style="font-weight: bold;">
      </el-form-item>
      <van-form>
        <van-cell
          :is-link="!InvoicingInfo.showForm"
          :clickable="!InvoicingInfo.showForm"
          :title="$t('INVOICINGINFO.CONTACTSINFO.NAME')"
          :value="invoicingContacts"
          @click="showContactsList"
          required
        ></van-cell>
        <van-cell :is-link="!InvoicingInfo.showForm" :title="$t('INVOICINGINFO.CONTACTSINFO.PHONE')" :value="contactPhone" v-if="choseContactsInfo"></van-cell>
        <van-cell :is-link="!InvoicingInfo.showForm" :title="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')" :value="contactEmail" v-if="choseContactsInfo"></van-cell>
      </van-form>
    </el-form>
    <!-- <el-form label-width="110px" class="info_form">
      <el-form-item :label="$t('H5INVOICINGINFO.INVOICINGCONTACTSTITLE')" style="text-align: right;font-weight: bold;">
      </el-form-item>
      <van-form>
        <van-field 
          v-model="contactInfo.email" 
          :label="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')" 
          :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.EMAIL')})" 
          :rules="[{ validator, message: $t('USERDIALOG.GUESTEMAIL2') }]"
        />
        <van-field type="tel" 
          v-model="contactInfo.phone"
          :label="$t('INVOICINGINFO.CONTACTSINFO.PHONE')" 
          :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.PHONE')})"
          :rules="[{ pattern: /^1[3456789]\d{9}$/, message: $t('MANUAL.VALIDATEPHONEFORMAT') }]"/>
      </van-form>
    </el-form> -->
    <!-- 接收方式 end -->
    <div style="margin: 0 16px;">
      <van-button round block type="info" native-type="submit" @click="saveInvoiceRecoed" v-if="!InvoicingInfo.showForm">{{ $t('INVOICINGBUTTON.SUBMIT')}}</van-button>
      <van-button round block type="info" native-type="submit" @click="resentInvoice" v-if="isShowRepeatEmail">{{ $t('INVOICINGBUTTON.RESENT')}}</van-button>
    </div>
    <!-- 开票说明 start -->
    <van-action-sheet v-model:show="instructionDialog" :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.INSTRUCTION')">
      <div style="padding: 2rem 2rem 16rem;font-size: 14px;">
        <span v-html="$t('INVOICINGINFO.INVOICINGDETAILINFO.INSTRUCTIONMSG')" ></span>
      </div>
    </van-action-sheet>
    <!-- 开票说明 end -->
    <!-- 发票抬头 start -->
    <van-action-sheet v-model:show="choseInvoiceHeader" :actions="headerActions" @select="choseHeaderActions" :cancel-text="$t('MESSAGE.CONFIRMCANCELTEXT')"/>
    
      <van-action-sheet v-model:show="showCustomDetailDialog" :title="$t('H5INVOICINGINFO.INVOICINGLISTTITLE')">
        <van-list class="customList" v-model="loading" :finished="finished" :immediate-check=false :offset="100" @load="onLoadInvoiceHeader">
          <div>
            <van-address-list v-model="chosenAddressId" :list="invoicingCustomDetailList" :add-button-text="$t('INVOICINGBUTTON.ADDINVOICING')" @edit="editCustomHeader" @select="choseHeader">
            </van-address-list>
          </div>
        </van-list>
      </van-action-sheet>
    <van-action-sheet v-model:show="showInstructionDetailDialog" :title="$t('H5INVOICINGINFO.INVOICINGLISTTITLE')">
      <div style="padding: 0 0 10rem;">
        <van-address-list v-model="chosenAddressId" :list="invoicingDetailList" :default-tag-text="$t('INVOICINGINFO.DEFAULT')" :add-button-text="$t('INVOICINGBUTTON.ADDINVOICING')" @add="addHeader" @edit="editHeader" @select="choseHeader">
          <template #item-bottom="item">
            <van-tag round  type="primary" style="margin-left: 3rem;">{{ item.tag }}</van-tag>
          </template>
        </van-address-list>
      </div>
    </van-action-sheet>
    <!-- 发票抬头 end -->
    <!-- 开票类型 start -->
    <van-action-sheet v-model:show="showInstructionTypeDialog" :title="$t('H5INVOICINGINFO.INVOICINGTYPETITLE')">
      <div style="padding: 2rem 2rem 20rem;">
        <van-radio-group v-model="instructionType">
          <van-cell-group>
            <van-cell :title="$t('INVOICINGTYPE.NORMAL')" :label="invoicingTypeTips" clickable @click="choseInstructionType('1')">
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell>
            <van-cell :title="$t('INVOICINGTYPE.APPRECIATE')" :label="invoicingTypeTips" clickable @click="choseInstructionType('2')">
              <template #right-icon>
                <van-radio name="2" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-action-sheet>
    <!-- 开票类型 end -->
    <!-- 发票抬头详情 start -->
    <van-popup v-model:show="showInvoicingDetailDialog" closeable close-icon-position="top-left" position="right" style="width: 100%;height: 100%;">
      <van-nav-bar :title="$t('INVOICINGBUTTON.DEIT')" :border="false"/>
      <van-form ref="invoicingRules">
        <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
        <van-cell-group>
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADERTYPE')" :value="InvoicingInfo.getAddInvoicingInfo" />
          <van-field v-model="InvoicingInfo.invoicingDetailData.headerName" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')" :rules="invoicingRules.headerName" required name="headerName"/>
          <van-field v-model="InvoicingInfo.invoicingDetailData.taxCode" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')" :rules="invoicingRules.taxCode" :required="checkCorporationInvoicing" name="taxCode"/>
        </van-cell-group>
        <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
        <van-cell :title="$t('INVOICINGBUTTON.ISFIRST')" style="color: #646566;">
          <template #right-icon>
            <van-switch v-model="InvoicingInfo.invoicingDetailData.isDefault" size="20" />
          </template>
        </van-cell>
        <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
        <van-cell-group>
          <van-field v-model="InvoicingInfo.invoicingDetailData.bank" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')" name="bank"/>
          <van-field v-model="InvoicingInfo.invoicingDetailData.bankAccountNumber" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')" :rules="invoicingRules.bankAccountNumber" name="bankAccountNumber"/>
          <van-field v-model="InvoicingInfo.invoicingDetailData.registeredAddress" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')" :rules="invoicingRules.registeredAddress" name="registeredAddress"/>
          <van-field v-model="InvoicingInfo.invoicingDetailData.registeredPhone" :label="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')" :rules="invoicingRules.registeredPhone" name="registeredPhone"/>
        </van-cell-group>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" @click="saveDetail">{{ $t("INVOICINGBUTTON.SAVE") }}</van-button>
          <van-button round block type="info" native-type="delete" style="margin-top: 1rem;" @click="deleteHeader" v-if="showDeleteButton">{{ $t("INVOICINGBUTTON.DELETE") }}</van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- 发票抬头详情 end -->
    <!-- 公司发票抬头详情 start -->
    <van-popup v-model:show="showCustomInvoicingDetailDialog" closeable close-icon-position="top-left" position="right" style="width: 100%;height: 100%;">
      <van-nav-bar :title="$t('INVOICINGINFO.CORPORATERETRIEVEDINVOICEHEADER')" :border="false"/>
      <van-form>
        <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
        <van-cell-group>
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')" :value="InvoicingInfo.invoicingDetailData.headerName" />
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')" :value="InvoicingInfo.invoicingDetailData.taxCode" />
        </van-cell-group>
        <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
        <van-cell-group>
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNAME')" :value="InvoicingInfo.invoicingDetailData.bank" />
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.BANKNUMBER')" :value="InvoicingInfo.invoicingDetailData.bankAccountNumber" />
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDADDRESS')" :value="InvoicingInfo.invoicingDetailData.registeredAddress" />
          <van-cell :title="$t('INVOICINGINFO.INVOICINGDETAILINFO.REGISTEREDPHONE')" :value="InvoicingInfo.invoicingDetailData.registeredPhone" />
        </van-cell-group>
      </van-form>
    </van-popup>
    <!-- 公司发票抬头详情 end -->
    <!-- 联系人列表 start -->
    <van-action-sheet v-model:show="showContactsListDialog" :title="$t('H5INVOICINGINFO.CONTACTSTITLE')">
    <div style="padding: 0 0 10rem;">
      <van-address-list v-model="chosenAddressId" :list="contactsList" :default-tag-text="$t('INVOICINGINFO.DEFAULT')" :add-button-text="$t('INVOICINGBUTTON.ADDCONTACTS')" @add="addContacts" @edit="editContacts" @select="choseContacts">
      </van-address-list>
    </div>
  </van-action-sheet>
  <!-- 联系人列表 end -->
  <!-- 联系人详情 start -->
  <van-popup v-model:show="showContactsDetailDialog" closeable close-icon-position="top-left" position="right" style="width: 100%;height: 100%;">
    <van-nav-bar :title="$t('INVOICINGINFO.CONTACTSINFO.CONTACTSMSG')" :border="false"/>
    <van-form  ref="contactsDetailData">
      <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
      <van-cell-group>
        <van-field 
          v-model="InvoicingInfo.contactsDetailData.personName" 
          :label="$t('INVOICINGINFO.CONTACTSINFO.NAME')"
          :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.NAME')})" 
          required
          name="personName"
          :rules="[{ required: true, trigger:'onBlur', message: $t('MANUAL.VALIDATECONTACTNAME')  }]"
        />
        <van-field type="tel" 
          v-model="InvoicingInfo.contactsDetailData.personPhone"
          :label="$t('INVOICINGINFO.CONTACTSINFO.PHONE')" 
          :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.PHONE')})"
          required
          name="personPhone"
          :rules="[{ pattern: /^1[3456789]\d{9}$/, message: $t('MANUAL.VALIDATEPHONEFORMAT') }]"
        />
        <van-field 
          v-model="InvoicingInfo.contactsDetailData.personEmail" 
          :label="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')" 
          :placeholder="$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : $t('INVOICINGINFO.CONTACTSINFO.EMAIL')})" 
          required
          name="personEmail"
          :rules="[{ validator, message: $t('USERDIALOG.GUESTEMAIL2') }]"
        />
      </van-cell-group>
      <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
      <van-cell :title="$t('INVOICINGBUTTON.ISFIRST')" style="color: #646566;">
        <template #right-icon>
          <van-switch v-model="InvoicingInfo.contactsDetailData.isDefault" size="20" />
        </template>
      </van-cell>
      <div style="padding-top: 1rem;background-color: #f1f3f5;"></div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="saveContactsDetail">{{ $t("INVOICINGBUTTON.SAVE") }}</van-button>
        <van-button round block type="info" native-type="delete" style="margin-top: 1rem;" @click="deleteContacts" v-if="showContactsDeleteButton">{{ $t("INVOICINGBUTTON.DELETE") }}</van-button>
      </div>
    </van-form>
  </van-popup>
  <!-- 联系人详情 end -->
  <!-- 重发电子发票 start -->
  <van-action-sheet v-model:show="showResentInvoiceDialog" :title="$t('INVOICINGBUTTON.RESENT')" style="height: 30rem;">
      <div style="padding: 2rem 2rem 0;">
        <van-form  ref="repeatEmailData">
          <van-field v-model="resentInvoiceEmail" :label="$t('INVOICINGINFO.CONTACTSINFO.EMAIL')" required name="resentInvoiceEmail" :rules="[{ validator, message: $t('USERDIALOG.GUESTEMAIL2') }]"/>
          <div style="margin:16px;padding-top: 4rem;">
            <van-button round block type="info" native-type="submit" @click="repeatEmail">{{ $t("HOTELORDEREMAIL.REPEAT") }}</van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>
    <!-- 重发电子发票 end -->
  </div>
</template>
<script>
import { isEmail } from "@/utils/utils.js";
import { showDialog, showConfirmDialog } from "vant";
export default {
  name: "invoicingH5",
  inject: ['InvoicingInfo'],
  data() {
    return {
      roomFees: "",
      serviceFees: "",
      serviceFeesChecked: false,
      instructionDialog:false,
      showInstructionDetailDialog:false,
      showInvoicingDetailDialog:false,
      contactInfo:{
        name:"",
        phone:"",
        email:"",
      },
      invoicingHeader:this.$t('H5INVOICINGINFO.HEADERPLACEHOLDER'),
      invoicingTypeTips:this.$t('H5INVOICINGINFO.INVOICINGTYPE_NORMALTIPS'),
      chosenAddressId: '',
      invoicingDetailList: [],
      showTaxRegisterNumber:false,
      taxCode:"",
      showInstructionTypeDialog:false,
      instructionType:"",
      showDeleteButton:true,
      invoicingContacts:this.$t('H5INVOICINGINFO.INVOICINGCONTACTSTITLE'),
      contactPhone:"",
      contactEmail:"",
      showContactsListDialog:false,
      contactsList: [],
      showContactsDetailDialog:false,
      showContactsDeleteButton:false,
      choseContactsInfo:false,
      checkCorporationInvoicing:true,
      showResentInvoiceDialog:false,
      resentInvoiceEmail:"",
      choseInvoiceHeaderNum:1,
      isShowRepeatEmail:false,
      choseInvoiceHeader:false,
      headerActions: [{ name: this.$t('INVOICINGINFO.PERSONALINVOICEHEADER'),value:1}, { name: this.$t('INVOICINGINFO.CORPORATERETRIEVEDINVOICEHEADER'),value:2 },],
      showCustomDetailDialog:false,
      showCustomInvoicingDetailDialog:false,
      invoicingCustomDetailList:[],
      invoicingCustomData:[],
      loading: false,
      finished: false,
      totalCount:0,
    };
  },
  computed: {
    getTotalPrice(){
      return (item) => {
        return this.$currencySign[item.currencyCode] + " " + item.totalPrice;
      }
    },
    getInvoicingPrice(){
      return (item) => {
        return this.$currencySign[item.currencyCode] + " " + (Number(this.roomFees) + Number(this.serviceFees)).toFixed(2);
      }
    },
    getInvoicingDetail(){
      return (item) => {
        return this.$t("INVOICINGINFO.INVOICINGDETAIL",{roomFees : this.roomFees ,serviceFees: this.serviceFees});
      }
    },
    getTitleType(){
      return (item) => {
        switch (item) {
          case "1":
            return this.$t("INVOICINGHEADERTYPE.CORPORATION");
          case "2":
            return this.$t("INVOICINGHEADERTYPE.PERSONS");
          default:
            return this.$t("INVOICINGHEADERTYPE.NOCORPORATION");
        }
      }
    },
    invoicingRules() {
      return {
        "headerName": [{ required: true, message: this.$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : this.$t('INVOICINGINFO.INVOICINGDETAILINFO.HEADER')}), trigger: ["blur", "change"], },
                       { validator: this.validateInputNumber,message:this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputCharacters'), trigger: 'input' },
                       { validator: this.validateHeaderName,message:this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateHeaderName'), trigger: 'input' }],
        "taxCode": [{ required: this.checkCorporationInvoicing, message: this.$t('INVOICINGINFO.INVOICINGDETAILINFO.INPUTPLACEHOLDER',{MSG : this.$t('INVOICINGINFO.INVOICINGDETAILINFO.TAXREGISTERNUMBER')}), trigger: ["blur", "change"], },
                    { validator: this.validateIdentifier, message:this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputTaxNumber') ,trigger: 'input' }],
        "bankAccountNumber": [{ validator: this.validateInputNumber,message:this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputCharacters'), trigger: 'input' }],
        "registeredAddress": [{ validator: this.validateInputNumber,message:this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputCharacters'), trigger: 'input' }],
        "registeredPhone": [{ validator: this.validateInputNumber,message:this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateInputCharacters'), trigger: 'input' }],
      }
    },
  },
  watch: {},
  mounted() {
  },
  methods: {
    validateInputNumber(val) {
      return new Promise((resolve) => {
        const maxLength = 100; // 最大字符数
        const maxChineseLength = 50; // 最大汉字数
        let length = 0;
        
        for (let i = 0; i < val.length; i++) {
          if (val.charCodeAt(i) > 127) {
            length += 2; // 汉字长度计为2
          } else {
            length += 1; // 英文字母和其他字符长度计为1
          }
        }

        if (length > maxLength) {
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    validateIdentifier(val) {
      return new Promise((resolve) => {
        const pattern = /^[A-Za-z0-9]{7,20}$/;
        if (val === '') {
          return resolve(true);
        } else if (!pattern.test(val)) {
          resolve(false);
          //reject(new Error('识别号必须是7-20位的数字或字母'));
        } else {
          resolve(true);
        }
      });
    },
    validateHeaderName(val) {
      return new Promise((resolve) => {
        const invoicingTitle = this.InvoicingInfo.invoicingTitle;
        if ((invoicingTitle === 1 && val === this.$t('INVOICINGINFO.INVOICINGCOMPANY')) || (invoicingTitle === 2 && val === this.$t('INVOICINGINFO.INVOICINGCOMPANY1'))) {
          resolve(false);
        }else {
          resolve(true);
        }
      });
    },
    instruction(){
      this.instructionDialog = true;
    },
    showInvoicingType(){
      this.showInstructionTypeDialog = true;
      this.instructionType = String(this.InvoicingInfo.choseInvoicingType);
    },
    choseInstructionType(val){
      this.instructionType = val;
      this.InvoicingInfo.choseInvoicingType = parseInt(val);
      this.showInstructionTypeDialog = false;
      if(this.InvoicingInfo.choseInvoicingType == 2){
        this.InvoicingInfo.showInvoiceTypeRadio = true;
        this.InvoicingInfo.choseinvoicing.invoiceType = "3";
      }else{
        this.InvoicingInfo.showInvoiceTypeRadio = false;
        this.InvoicingInfo.choseinvoicing.invoiceType = "2";
      }
    },
    validator(val) {
      return isEmail(val);
    },
    // #region 发票抬头功能
    showInvoiceHeader(){
      this.InvoicingInfo.pageIndex = 1;
      this.InvoicingInfo.getInvoiceHeader().then(() => {
        if(this.InvoicingInfo.customInvoiceHeaderList.length > 0){
          this.choseInvoiceHeader = true;
        }else{
          this.showInvoicingList();
        }
      });
    },
    choseHeaderActions(item){
      this.choseInvoiceHeader = false;
      this.choseInvoiceHeaderNum = item.value;
      if(item.value == 1){
        this.showInvoicingList();
      }else if(item.value == 2){
        this.invoicingCustomDetailList = [];
        this.invoicingCustomData = [];
        this.finished = false;
        this.showInvoicingCustomList();
      }
    },
    onLoadInvoiceHeader(){
      this.InvoicingInfo.pageIndex =  this.InvoicingInfo.pageIndex + 1;
      this.InvoicingInfo.getInvoiceHeader().then(() => {
        this.loading = false;
        this.showInvoicingCustomList();
        this.totalCount = this.InvoicingInfo.pageIndex * this.InvoicingInfo.pageSize;
        if(this.totalCount >= this.InvoicingInfo.totalCount){
          this.finished = true;
        }
      });
    },
    showInvoicingCustomList(){
      this.invoicingCustomData.push(...this.InvoicingInfo.customInvoiceHeaderList);
      this.showInvoicingDetailDialog = false;
      if(this.InvoicingInfo.customInvoiceHeaderList.length > 0){
        for (const element of this.InvoicingInfo.customInvoiceHeaderList) {
          let param = {
            id:element.id,
            name: element.headerName,
            tel: "",
            address: element.taxCode,
            tag:this.getTitleType(element.invoiceType),
            isDefault:element.isDefault,
          };
          this.invoicingCustomDetailList.push(param);
        }
      }
      this.showCustomDetailDialog = true;
    },
    showInvoicingList(){
      this.showInvoicingDetailDialog = false;
      this.invoicingDetailList = [];
      if(this.InvoicingInfo.invoicingData.length > 0){
        for (const element of this.InvoicingInfo.invoicingData) {
          let param = {
            id:element.id,
            name: element.headerName,
            tel: "",
            address: element.taxCode,
            tag:this.getTitleType(element.invoiceType),
            isDefault:element.isDefault,
          };
          this.invoicingDetailList.push(param);
        }
      }
      this.showInstructionDetailDialog = true;
    },
    choseHeader(val){
      let detail;
      if(this.choseInvoiceHeaderNum == 1){
        detail = this.InvoicingInfo.invoicingData.find((item) => {
          if (item.id === val.id) {
            return item;
          }
        })
      }else{
        detail = this.invoicingCustomData.find((item) => {
          if (item.id === val.id) {
            return item;
          }
        })
      }
      this.InvoicingInfo.choseinvoicing = detail;
      this.invoicingHeader = detail.headerName;
      this.taxCode = detail.taxCode;
      this.showTaxRegisterNumber = detail.invoiceType == "1";
      this.showInstructionDetailDialog = false;
      this.showCustomDetailDialog = false;
    },
    addHeader(){
      if(this.InvoicingInfo.invoicingData.length > 2){
        showDialog({
          message: this.$t("H5INVOICINGINFO.TIPS"),
          theme: 'round-button',
        });
      }else{
        this.showInvoicingDetailDialog = true;
        this.showDeleteButton = false;
        this.InvoicingInfo.invoicingDetailData = {
          userId:this.InvoicingInfo.orderInfo.userId,
          customerCode: this.InvoicingInfo.orderInfo.customerCode,
          invoiceType: this.InvoicingInfo.choseinvoicing.invoiceType,
        };
      }
    },
    editCustomHeader(val){
      let detail = this.invoicingCustomData.find((item) => {
        if (item.id === val.id) {
          return item;
        }
      })
      this.InvoicingInfo.invoicingDetailData = detail;
      this.showCustomInvoicingDetailDialog = true;
    },
    editHeader(val){
      let detail = this.InvoicingInfo.invoicingData.find((item) => {
        if (item.id === val.id) {
          return item;
        }
      })
      // this.InvoicingInfo.getInvoiceHeader({ 
      //   id: val.id,
      // });
      this.showInvoicingDetailDialog = true;
      this.showDeleteButton = true;
      this.InvoicingInfo.invoicingDetailData = detail;
    },
    saveDetail(){
      const save = () => {
        this.InvoicingInfo.saveInvoiceHeader({
          params: this.InvoicingInfo.invoicingDetailData,
          key:"Edit_H5"
        });
      };
      if(this.InvoicingInfo.invoicingDetailData.invoiceType== "1"){
        this.$refs.invoicingRules.validate(["headerName","bankAccountNumber","registeredAddress","registeredPhone"])
          .then(save)
          .catch(() => {});
      }else if(this.InvoicingInfo.invoicingDetailData.invoiceType== "2"){
        this.$refs.invoicingRules.validate(["headerName","bankAccountNumber","registeredAddress","registeredPhone"])
          .then(save)
          .catch(() => {});
      }else if(this.InvoicingInfo.invoicingDetailData.invoiceType== "3"){
        this.$refs.invoicingRules.validate()
          .then(save)
          .catch(() => {});
      }
    },
    deleteHeader(){
      showConfirmDialog({
        message: this.$t("INVOICINGINFO.DELETEMSG"),
        confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
        cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
      })
      .then(() => {
        var data = this.InvoicingInfo.invoicingDetailData;
        let Params = {
          id: data.id,
          userId: data.userId,
          customerCode: data.customerCode,
          invoiceType: data.invoiceType,
          headerName: data.headerName,
          taxCode: data.taxCode,
          bank: data.bank,
          bankAccountNumber: data.bankAccountNumber,
          registeredAddress: data.registeredAddress,
          registeredPhone: data.registeredPhone,
          isDefault: data.isDefault,
          isDel: 1,
        };
        this.InvoicingInfo.saveInvoiceHeader({ 
          params: Params,
          key:"Delete_H5"
        });
      })
      .catch(() => {});
    },
    changeInvoiceType(){
      if(this.$refs["invoicingRules"] !=undefined){
        this.$refs["invoicingRules"].resetValidation();//重置表单
      }
      if(this.InvoicingInfo.choseinvoicing.invoiceType == "1"){
        this.checkCorporationInvoicing = false;
      }else if(this.InvoicingInfo.choseinvoicing.invoiceType == "2"){
        this.checkCorporationInvoicing = false;
      }else if(this.InvoicingInfo.choseinvoicing.invoiceType == "3"){
        this.checkCorporationInvoicing = true;
      }
    },
    // #endregion 
    // #region 联系人功能
    showContactsList(){
      this.showContactsDetailDialog = false;
      this.contactsList = [];
      if(this.InvoicingInfo.contactsData.length > 0){
        for (const element of this.InvoicingInfo.contactsData) {
          let param = {
            id:element.id,
            name: element.personName,
            tel: element.personPhone,
            address: element.personEmail,
            isDefault:element.isDefault,
          };
          this.contactsList.push(param);
        }
      }
      this.showContactsListDialog = true;
    },
    addContacts(){
      if(this.InvoicingInfo.contactsData.length > 2){
        showDialog({
          message: this.$t("H5INVOICINGINFO.TIPS"),
          theme: 'round-button',
        });
      }else{
        this.showContactsListDialog = false;
        this.showContactsDetailDialog = true;
        this.showContactsDeleteButton = false;
        this.InvoicingInfo.contactsDetailData = {
          userId:this.InvoicingInfo.orderInfo.userId,
          customerCode: this.InvoicingInfo.orderInfo.customerCode,
        };
      }
    },
    editContacts(val){
      this.InvoicingInfo.getInvoiceContactList({ 
        id: val.id,
      });
      this.showContactsListDialog = false;
      this.showContactsDetailDialog = true;
      this.showContactsDeleteButton = true;
      //this.invoicingDetail = detail;
    },
    saveContactsDetail(){
      this.$refs.contactsDetailData.validate().then(()=>{
        this.InvoicingInfo.saveInvoiceContact({
          params: this.InvoicingInfo.contactsDetailData,
          key:"Edit_H5"
        });
      }).catch(() => {})
    },
    choseContacts(val){
      let detail = this.InvoicingInfo.contactsData.find((item) => {
        if (item.id === val.id) {
          return item;
        }
      })
      this.InvoicingInfo.choseContact = detail;
      this.invoicingContacts = detail.personName;
      this.contactPhone = detail.personPhone;
      this.contactEmail = detail.personEmail;
      this.choseContactsInfo = true;
      this.showContactsListDialog = false;
    },
    deleteContacts(){
      showConfirmDialog({
        message: this.$t("INVOICINGINFO.DELETEMSG"),
        confirmButtonText: this.$t("INVOICINGBUTTON.CONFIRM"),
        cancelButtonText: this.$t("INVOICINGBUTTON.CANCEL"),
      })
      .then(() => {
        var data = this.InvoicingInfo.contactsDetailData;
        let Params = {
          id: data.id,
          userId: data.userId,
          customerCode: data.customerCode,
          personName: data.personName,
          personPhone: data.personPhone,
          personEmail: data.personEmail,
          isDefault: data.isDefault,
          isDel: 1,
        };
        this.InvoicingInfo.saveInvoiceContact({ 
          params: Params,
          key:"Delete_H5"
        });
      })
      .catch(() => {});
    },
    // #endregion
     saveInvoiceRecoed(){
      const invoicingTitle = this.InvoicingInfo.invoicingTitle;
      if(this.invoicingHeader == this.$t('H5INVOICINGINFO.HEADERPLACEHOLDER')){
        showDialog({
          message: this.$t('H5INVOICINGINFO.HEADERPLACEHOLDER'),
          theme: 'round-button',
        })
      }else if(this.invoicingContacts == this.$t('H5INVOICINGINFO.INVOICINGCONTACTSTITLE')){
        showDialog({
          message: this.$t('H5INVOICINGINFO.INVOICINGCONTACTSTITLE'),
          theme: 'round-button',
        })
      }else if ((invoicingTitle === 1 && this.invoicingHeader === this.$t('INVOICINGINFO.INVOICINGCOMPANY')) || (invoicingTitle === 2 && this.invoicingHeader === this.$t('INVOICINGINFO.INVOICINGCOMPANY1'))) {
        showDialog({
          message: this.$t('INVOICINGINFO.INVOICINGDETAILINFO.ValidateHeaderName'),
          theme: 'round-button',
        })
      }else{
        this.InvoicingInfo.saveInvoiceRecoed({ 
          params: {
            bookingCode:this.$route.query.orderId,
            orderAmount:this.InvoicingInfo.orderInfo.totalPrice,
            invoiceAmount: Number(this.roomFees).toFixed(2),
            invoiceTypes:this.InvoicingInfo.choseInvoicingType,
            isServiceFeeInvoice:this.serviceFeesChecked,
            serviceFeeInvoiceTypes:this.InvoicingInfo.choseServiceFeesInvoicingType,
            customerCode:this.InvoicingInfo.orderInfo.customerCode,
            userID:this.InvoicingInfo.orderInfo.userId,
            headerName:this.InvoicingInfo.choseinvoicing.headerName,
            invoiceHeaderType:this.InvoicingInfo.choseinvoicing.invoiceType,
            taxCode:this.InvoicingInfo.choseinvoicing.taxCode,
            bank:this.InvoicingInfo.choseinvoicing.bank,
            bankAccountNumber:this.InvoicingInfo.choseinvoicing.bankAccountNumber,
            registeredAddress:this.InvoicingInfo.choseinvoicing.registeredAddress,
            registeredPhone:this.InvoicingInfo.choseinvoicing.registeredPhone,
            contactPerson:this.InvoicingInfo.choseContact.personName,
            contactPhone:this.InvoicingInfo.choseContact.personPhone,
            contectEmail:this.InvoicingInfo.choseContact.personEmail,
            serviceFeeAmount:Number(this.serviceFees).toFixed(2),
          },
          key:"Save"
        });
      }
    },
    resentInvoice(){
      this.showResentInvoiceDialog = true;
    },
    repeatEmail(){
      this.$refs.repeatEmailData.validate().then(()=>{
        this.InvoicingInfo.repeatEmail({
          params: {
            orderNumber:this.$route.query.orderId,
            reEmailTo:this.resentInvoiceEmail
          },
          key:"H5"
        });
      }).catch(() => {})
      
    }
  },
};
</script>
<style scoped>
.el-form-item{
    margin-bottom: 0px!important;
}
.info_form{
    background-color: white;
    margin: 1rem;
    border-radius: 1rem;
}
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: -2rem;
  height: 2px;
  background-color: #fc6640;
}
.van-tag--danger{
  background-color: #fc6640;
}
.van-button--danger{
  background-color: #fc6640;
  border: 1px solid #fc6640;
}
::v-deep .van-address-item .van-radio__icon--checked .van-icon {
  background-color: #fc6640;
  border-color: #fc6640;
}
/* .van-cell{
  padding: 10px 16px 10px 0;
} */
.van-address-item:not(:last-child) {
  margin-bottom: 0px;
}
.van-cell__value{
  text-align: left;
}
.van-address-item__name{
  font-size: 14px;
}
.van-button--info{
  background-color: #fc6640;
  border-color: #fc6640;
}
.van-radio--horizontal{
  margin-right: 6px;
  font-size: 14px;
  padding: 1rem 0 1rem 0;
}
::v-deep .el-form-item__label{
  text-align: left;
  margin-left: 2rem;
}
.van-radio-group--horizontal{
  justify-content: space-around;
}
::v-deep .customList .van-address-list {
  padding: 0px;
}
::v-deep .customList .van-address-list__bottom{
  display: none;
}
</style>